import { createBrowserRouter } from "react-router-dom";
 import App from "../layouts/App.js"
 import UserLogin from "../components/user/Userlogin/UserLogin.jsx";
import ExpertLogin from "../components/Expert/ExpertLogin/ExpertLogin.jsx";
 import InQuery from "../components/inquery/InQuery.jsx";
import UserPanel from "../components/user/UserPanel/UserPanel.jsx";
import ExpertRequest from "../components/user/ExpertRequest/ExpertRequest.jsx";
import Support from "../components/user/Support/Support.jsx";
import Private from "./privateroute.js";
import Requests from "../components/user/Requests/Requests.jsx";
import Message from "../components/user/Message/Message.jsx";
import RealEstate from "../components/user/RealState/RealState.jsx";
import AboutUs from "../components/AboutUs/AboutUs.jsx";
import Terms from "../components/Terms/Terms.jsx";
import Contact from "../components/contact/Contact.jsx";
import ExpertPanel from "../components/Expert/ExpertPanel/ExpertPanel.jsx";
import ExpertSupport from "../components/Expert/ExpertSupport/Support.jsx";
import ExpertMessage from "../components/Expert/ExpertMessage/ExpertMessage.jsx"
import MyRequests from "../components/Expert/MyRequests/MyRequests.jsx";
import Wallet from "../components/Expert/wallet/Wallet.jsx";
import Statistics from "../components/Expert/Statistics/Statistics.jsx";
import NewRequest from "../components/Expert/MyRequests/NewRequest.jsx";
import Times from "../components/Expert/times/Times.jsx";
import ChangePass from "../components/Expert/change-pass/ChangePass.jsx";
import Bill from "../components/Bill/Bill.jsx";
import AdminPanel from "../components/Admin/adminPanel/AdminPanel.jsx";
import AdminExperts from "../components/Admin/Experts/Experts.jsx";
import AdminUsers from "../components/Admin/Users/AdminUsers.jsx";
import AdminRequests from "../components/Admin/Requests/AdminRequests.jsx";
import AddRealEstate from "../components/Admin/realestate/AddRealEstate.jsx";
import ExpertPage from "../components/Admin/Experts/ExpertPage.jsx";
import UserPage from "../components/Admin/Users/UserPage.jsx";
import AdminStatistics from "../components/Admin/statistics/Statistics.jsx";
import AddExpert from "../components/Admin/addExpert/AddExpert.jsx";
import Reports from "../components/Admin/Reports/Reports.jsx";
import AdminSuport from "../components/Admin/suport/AdminSuport.jsx";
import AdminSetting from "../components/Admin/Setting.jsx/Setting.jsx";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: (
            <h3 className="text-center">چیزی پیدا نکردیم متاسفانه 🤗 ...</h3>
        ),
    },
    {
        path: "userlogin",
        element: <UserLogin />,

    },
    {
        path: "expertlogin",
        element: <ExpertLogin />,

    },
    {
        path: "inquery",
        element: <InQuery />,

    },
    {
        path: "aboutus",
        element: <AboutUs />,

    },
    {
        path: "terms",
        element: <Terms />,

    },
    {
        path: "contact",
        element: <Contact />,

    },
    {
        path: "pay/bill/:id",
        element: <Bill />,

    },
    {
        path: "/user",
        element: <Private><UserPanel/></Private>,
        children:[
            {
                path: "request",
                element: <ExpertRequest />,
            },
            {
                path: "support",
                element: <Support />,
            },
            {
                path: "requests",
                element: <Requests />,
            },
            {
                path: "messages",
                element: <Message />,
            },
            {
                path: "real-estate",
                element: <RealEstate />,
            },
        ]
    },
    {
        path : "expert",
        element: <ExpertPanel/>,
        children: [
            {
                path: "requests",
                element: <MyRequests />,
            },
            {
                path: "support",
                element: <ExpertSupport />,
            },
            {
                path: "messages",
                element: <ExpertMessage />,
            },
            {
                path: "wallet",
                element: <Wallet />,
            },
            {
                path: "statistics",
                element: <Statistics />,
            },
            {
                path: "new-request",
                element: <NewRequest />,
            },
            {
                path : "times",
                element: <Times/>
            },
            {
                path:"change-password",
                element : <ChangePass/>
            },
        ]


    },
    {
        path : "admin",
        element: <AdminPanel/>,
        children: [
            {
                path: "experts",
                element: <AdminExperts />,
            },
            {
                path: "experts/:id",
                element: <ExpertPage />,
            },
            {
                path: "users",
                element: <AdminUsers />,
            },
            {
                path: "users/:id",
                element: <UserPage />,
            },
            {
                path: "requests",
                element: <AdminRequests />,
            },
            {
                path: "add-new-realestate",
                element: <AddRealEstate />,
            },
            {
                path: "statistics",
                element: <AdminStatistics />,
            },
            {
                path: "new-expert",
                element: <AddExpert />,
            },
            {
                path: "reports",
                element: <Reports/>,
            },
            {
                path: "support",
                element: <AdminSuport/>,
            },
            {
                path: "setting",
                element: <AdminSetting/>,
            },
          
        ]


    }
]);